export default {
    imageAIFormRules: {
        enterDescription: 'Vennligst skriv inn beskrivelsen',
        invalidDescription: 'Vennligst skriv inn en gyldig beskrivelse',
        enterNumberOfVariations: 'Vennligst velg antall varianter',
        invalidNumberOfVariations: 'Du kan generere maksimalt 4 og minimum 1 variasjon',
        enterStyle: 'Vennligst velg minst én stil',
    },
};
